import { render, staticRenderFns } from "./CelebrateSampleCreate.vue?vue&type=template&id=7fc8048e&scoped=true"
import script from "./CelebrateSampleCreate.vue?vue&type=script&lang=js"
export * from "./CelebrateSampleCreate.vue?vue&type=script&lang=js"
import style0 from "./CelebrateSampleCreate.vue?vue&type=style&index=0&id=7fc8048e&lang=css"
import style1 from "./CelebrateSampleCreate.vue?vue&type=style&index=1&id=7fc8048e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8048e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc8048e')) {
      api.createRecord('7fc8048e', component.options)
    } else {
      api.reload('7fc8048e', component.options)
    }
    module.hot.accept("./CelebrateSampleCreate.vue?vue&type=template&id=7fc8048e&scoped=true", function () {
      api.rerender('7fc8048e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/CelebrateSampleCreate.vue"
export default component.exports